// Image Uploads
export const allowedMimeTypes = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/gif",
];
export const maxAllowedImageUploadSize = 5 * 1024 * 1024; // 5MB
